define.alias("shared/components/shared/publish/switcher/item/publish-method", "calendar/components/shared/publish/switcher/item/publish-method");